import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const ContentWriting = () => {

  const projects = [
    { title: "SEO Blog Strategy", desc: "Content that ranked on Google first page.", link: "#" },
  ];

  const testimonials = [
    { name: "Content Lead", role: "Editor", feedback: "High-quality and engaging content." },
    { name: "Startup Founder", role: "CEO", feedback: "Our conversions improved massively." },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[600px] h-[600px] bg-indigo-500/30 blur-[140px] rounded-full"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            Content That <span className="text-indigo-400">Drives Results</span>
          </h1>

          <p className="mt-6 text-gray-300 max-w-2xl mx-auto">
            Words that engage, convert, and build strong brand identity.
          </p>

          <div className="mt-10 flex gap-4 justify-center">
            <Link to="/contact" className="bg-indigo-500 px-8 py-4 rounded-full">
              Start Writing
            </Link>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="py-24 grid md:grid-cols-3 gap-8 max-w-6xl mx-auto px-6">
        {["Blogs","Website Copy","SEO Content","Email Writing","Scripts","Brand Voice"].map((i)=>(
          <div key={i} className="bg-white/5 p-6 rounded-xl border border-white/10 hover:scale-105 transition">
            <h3 className="text-indigo-400">{i}</h3>
          </div>
        ))}
      </section>

      {/* PROCESS */}
      <section className="py-24 text-center bg-[#0b1a35]">
        <h2 className="text-4xl font-bold mb-12">Our Writing Process</h2>
        <div className="grid md:grid-cols-4 gap-8">
          {["Research","Draft","Optimize","Publish"].map((step,i)=>(
            <div key={i}>
              <div className="text-indigo-400 text-2xl font-bold">{i+1}</div>
              <p>{step}</p>
            </div>
          ))}
        </div>
      </section>

      <ProjectsSection projects={projects} />
      <Testimonials testimonials={testimonials} />

      <section className="py-28 text-center bg-gradient-to-r from-indigo-500 to-purple-500">
        <h2 className="text-4xl font-bold">Let’s Tell Your Story ✍️</h2>
      </section>

    </div>
  );
};

export default ContentWriting;